<script lang="ts">
  import InvoicesBreadcrumb from "@retailer/svelte/Payments/InvoicesBreadcrumb.svelte";
  import InvoicesLayout from "@retailer/svelte/Payments/InvoicesLayout.svelte";
  import { onMount } from "svelte";

  const paymentsEnabled = window["$rootScope"].user.term_payments;
  if (!paymentsEnabled) window.location.href = "/";

  export let selectedTab: string = undefined;

  let newTabLabel: string = "Invoices";

  const onTabChange = (e: CustomEvent) => {
    selectedTab = e.detail;
  };

  onMount(() => {
    if (!selectedTab) selectedTab = "invoices";
  });

  $: {
    switch (selectedTab) {
      case "payment-settings":
        newTabLabel = "Payment Settings";
        break;
      case "credits":
        newTabLabel = "Credits";
        break;
      default:
        newTabLabel = "Invoices";
    }
  }

</script>

{#if paymentsEnabled}
  <InvoicesBreadcrumb heading={newTabLabel} />
  <InvoicesLayout on:tabChange={onTabChange} {selectedTab} />
{/if}
